import React, { useState, useRef } from 'react';
import CompanySearchWrapper from '@componentsV2/CompanySearch';
import PageLayout from '../../../../../components/layouts/WithHeader';
import useDesktop from '../../../../../hooks/useDesktop';
import ContactProfessional from '../../../../../components/ContactProfessional';
import { useFindProfessionalsStyles } from '../../../../../components/FindProfessionals/findProfessionalStyles';

const FindProfessional = () => {
  const [nameFilterChecked] = useState(false);
  const [showContactProfDialog, setShowContactProfDialog] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const isDesktop = useDesktop();
  const companySearchRef = useRef(null);
  const companyMapRef = useRef(null);

  const classes = useFindProfessionalsStyles();

  const contactCompany = (company) => {
    setSelectedCompany(company);
    setShowContactProfDialog(true);
  };

  const handleMapCompanyClick = (company) => {
    // When a company is clicked on the map ("Se firma"), show it in the search component
    if (
      companySearchRef?.current &&
      typeof companySearchRef.current.showCompanyProfile === 'function'
    ) {
      companySearchRef.current.showCompanyProfile(company);
    }
  };

  const handleResultClick = (company) => {
    // Open contact dialog when clicking company card in search results
    // Convert CompanySearchResult format to the format expected by ContactProfessional
    const companyData = {
      id: company.companyId,
      companyId: company.companyId,
      name: company.name,
      companyName: company.name,
      displayName: company.name,
      city: company.city,
      postalCode: company.postalCode,
      organizationNumber: company.organizationNumber,
      professions: company.professions,
      professionTypes: company.professions || [],
      logoUrl: company.logoUrl,
      // Address format that ContactProfessional might expect
      address:
        company.city && company.postalCode
          ? `${company.postalCode} ${company.city}`
          : company.city || company.postalCode || '',
    };
    contactCompany(companyData);
  };

  const handleOpenMapPopup = (company) => {
    // When opening a company profile from search, open the popup on the map
    if (
      companyMapRef?.current &&
      typeof companyMapRef.current.openPopupForCompany === 'function'
    ) {
      companyMapRef.current.openPopupForCompany(company);
    }
  };

  const handleDetailViewClose = () => {
    // When closing the detail view, close the map popup and refit bounds
    if (companyMapRef?.current) {
      if (typeof companyMapRef.current.closePopup === 'function') {
        companyMapRef.current.closePopup();
      }
      if (typeof companyMapRef.current.refitBounds === 'function') {
        companyMapRef.current.refitBounds();
      }
    }
  };

  return (
    <>
      <PageLayout
        minFullHeight
        lessMarginLeft={isDesktop}
        maxWidth={false}
        hideHeader={isDesktop}
        headerTitle="Finn håndverker"
        topLevelLayout
        // headerSearch={renderSearchFilterSection()}
        isSearching={nameFilterChecked}
        className={classes.findProfessionalHeader}
        noPaddingTop
        noPadding
      >
        <CompanySearchWrapper
          companySearchRef={companySearchRef}
          companyMapRef={companyMapRef}
          onResultClick={handleResultClick}
          onCompanyClick={handleMapCompanyClick}
          onOpenMapPopup={handleOpenMapPopup}
          onDetailViewClose={handleDetailViewClose}
          showMap={isDesktop}
          pageSize={15}
        />
        <ContactProfessional
          open={showContactProfDialog}
          onClose={() => setShowContactProfDialog(false)}
          company={selectedCompany}
        />
      </PageLayout>
    </>
  );
};

export default FindProfessional;
